import { defineStore } from 'pinia';
import { ref } from 'vue';

// Plain state holder — no fetches. Orchestration (checkAuth, logout)
// lives in composables/useAuth.
const useAuthStore = defineStore('auth', () => {
    const isAuthenticated = ref(false);

    function setAuthenticated(value: boolean): void {
        isAuthenticated.value = value;
    }

    return { isAuthenticated, setAuthenticated };
});

export { useAuthStore };
